/* eslint-disable no-undef */
import React from 'react';
import { Router } from 'react-router-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  Fuse,
  PreferencesProvider,
  SiteConfigManager,
  useCreatePreferencesState,
} from '@atlas/core';

import CustomStylesPortal from 'components/CustomStylesPortal/CustomStylesPortal';
import LayoutErrorFallback from 'components/Layout/LayoutErrorFallback';
import { BetBoosterGlobalContextProvider } from 'components/Sportsbook/BetBooster/BetBoosterGlobalContext';
import useThemeBootstrap from 'hooks/useThemeBootstrap';

export default function LayoutContainer({ children, history }) {
  const showTopNavigation = SiteConfigManager.getConfig(
    'config.config.sportsbook.showTopNavigationDesktop',
  );
  const favoritesState = useCreatePreferencesState();
  const classNames = cx('main', 'main_iframe', !showTopNavigation && 'full_iframe');

  useThemeBootstrap();

  return (
    <Fuse fallback={LayoutErrorFallback}>
      <Router history={history}>
        <BetBoosterGlobalContextProvider>
          <CustomStylesPortal />

          <PreferencesProvider value={favoritesState}>
            <main className={classNames}>{children}</main>
          </PreferencesProvider>
        </BetBoosterGlobalContextProvider>
      </Router>
    </Fuse>
  );
}

LayoutContainer.propTypes = {
  children: PropTypes.node,
  history: PropTypes.object,
};
